import { symbol } from 'prop-types';
import { Api } from '../../Api';
import { ListResult } from '../../interfaces';
import { ISettingsSecuritiesDto } from './interfaces';
import { ISettingsSecuritiesGetQuery } from './query';
import { ISettingsSecuritiesGetLogoParams } from './params';

export class Securities {
    private static _basePath = '/Security';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Securities._basePath}`;
        return {
            async get(query: ISettingsSecuritiesGetQuery) {
                const path = '/';
                return await Api.get<ListResult<ISettingsSecuritiesDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getLogo({ symbol }: ISettingsSecuritiesGetLogoParams) {
                const path = '/logo';
                const res = await fetch(`${basePath}/${symbol}${path}`);
                if (res.ok) {
                    const blob = await res.blob();
                    const imageUrl = URL.createObjectURL(blob);
                    return imageUrl;
                }
                return '';
            },

            async getAllSecurities(accountId: number) {
                const path = '/GetAllSecurities';
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                    query: {
                        accountId: accountId,
                    },
                });
            },

            async getSecurities(text: string) {
                const path = `/GetSecurities?search=${encodeURIComponent(text)}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },

            async addFavouriteStock(userId: any, symbol: any) {
                const path = `/AddFavouriteStock?userId=${userId}&symbol=${symbol}`;
                return await Api.post<any>({
                    path: `${basePath}${path}`,
                });
            },

            async removeFavouriteStock(userId: any, symbol: any) {
                const path = `/RemoveFavouriteStock?userId=${userId}&symbol=${symbol}`;
                return await Api.delete<any>({
                    path: `${basePath}${path}`,
                });
            },

            async getFavourite(userId: any) {
                const path = `/GetFavourite/${userId}`; // Use route param, not query
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
